import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Typography, IconButton } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineError } from "react-icons/md";
import { removeMessage } from "../../slice";

function ErrorAlert({ message = "", id }) {
  const dispatch = useDispatch();

  const handleRemoveMessage = useCallback(() => {
    dispatch(removeMessage(id));
  }, [dispatch, id]);

  useEffect(() => {
    let timer = setTimeout(() => handleRemoveMessage(), 4 * 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [message, handleRemoveMessage]);
  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor="#D65745"
      sx={{
        boxSizing: "border-box",
        padding: "0.6rem 0.4rem",
      }}
      borderRadius={3}
      my={1}
    >
      <IconButton onClick={handleRemoveMessage}>
        <AiOutlineClose color="#fff" size={20} />
      </IconButton>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography
          variant="h2"
          color="#fff"
          mr={1}
          // sx={{ width: "fit-content", whiteSpace: "nowrap" }}
        >
          {message}
        </Typography>
        <MdOutlineError color="#fff" size={20} style={{ minWidth: "25px", minHeight: "25px" }} />
      </Box>
    </Box>
  );
}

export default ErrorAlert;
